export default {
  screens: [
    {
      type: 'intro',
      title: '쇼메와 일본',
      content:
        '일본을 향한 쇼메의 관심은 브랜드 탄생의 초청기로 거슬러 올라갑니다. 일본 고객들 역시 쇼메의 주얼리에 큰 호기심을 갖고 쇼메에 대한 애정을 표현했습니다.',
      idYt: 'vGycDLMlTz4',
      videoCover: 'world/japan/video.jpg',
      desktop: {
        cover: 'world/japan/cover-1.jpg'
      },
      mobile: {
        cover: 'world/japan/mobile-cover-1.jpg',
        contentStyle: {
          width: '100%'
        },
        coverStyle: {
          width: '100%',
          bottom: '0%',
          left: '0',
          right: 'inherit',
          position: 'relative'
        }
      }
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/japan/triangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg',
        cover: 'world/japan/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/japan/mobileTriangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg'
      },
      content:
        '마리 앙투아네트 여왕의 래커 장식품에 경탄한 니토의 아이디어와 일본 수목에 대한 조세핀의 열정을 바탕으로 쇼메는 일본에서 영감을 받은 다양한 주얼리를 선보였습니다.<br/><br/> 특별히 제작된 하이 주얼리 컬렉션은 일본과 쇼메의 인연을 더욱 아름답게 이어줍니다.'
    },
    {
      type: 'column',
      leftImg: 'world/japan/columnLeft.jpg',
      middleImg: 'world/japan/columnMiddle.jpg',
      rightImg: 'world/japan/columnRight.jpg',
      title: '봄의 노래(Chant du Printemps)',
      content:
        '루비, 다이아몬드 및 오닉스와 래커의 선명한 컬러 대비와 기하학적 패턴으로 재해석된 자연의 모습이 담긴 주얼리 세트로,  자연에 심취한 일본 문화의 정수를 엿볼 수 있습니다.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/kr/worlds/japan.js